<div class="dialog-container">
  <h2 mat-dialog-title>Name of your script</h2>
  
  <form [formGroup]="form" (ngSubmit)="onSave()">
    <mat-dialog-content>
      <p class="dialog-description">Your script will appear under this name in-game</p>
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Script Name</mat-label>
        <input matInput formControlName="title" maxlength="64" placeholder="Enter script name">
        <mat-error *ngIf="form.get('title')?.hasError('required')">
          Script name is required
        </mat-error>
      </mat-form-field>
    </mat-dialog-content>
    
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="onCancel()">Cancel</button>
      <button mat-raised-button  type="submit" [disabled]="!form.valid">
        Apply Changes
      </button>
    </mat-dialog-actions>
  </form>
</div>
